export enum SortMode {
  Manual = 'Manual',
  ByColumn = 'ByColumn',
}
